// returns a custom event compatible with all browsers
var createCustomEvent = function createCustomEvent(eventType) {
  var customEvent;

  if (typeof Event === 'function') {
    customEvent = new Event(eventType, {
      bubbles: true
    });
  } else {
    customEvent = document.createEvent('Event');
    customEvent.initEvent(eventType, true, true);
  }

  return customEvent;
}; // returns a custom keyboard event compatible with all browsers

var createCustomKeyboardEvent = function createCustomKeyboardEvent(event) {
  var customKeyboardEvent;

  if (typeof KeyboardEvent === 'function') {
    customKeyboardEvent = new KeyboardEvent(event.type, event);
  } else {
    customKeyboardEvent = document.createEvent('Event');
    customKeyboardEvent.initEvent(event.type, true, true);
    customKeyboardEvent.keyCode = event.keyCode;
    customKeyboardEvent.charCode = event.charCode;
  }

  return customKeyboardEvent;
};
var setInputValueByRef = function setInputValueByRef(input, value, event) {
  if (event === void 0) {
    event = 'change';
  }

  if (!input) {
    return;
  }

  var previousValue = input.value;
  input.value = value || '';
  var tracker = input._valueTracker;

  if (tracker) {
    tracker.setValue(previousValue);
  } // 'change' instead of 'input', see https://github.com/facebook/react/issues/11488#issuecomment-381590324


  input.dispatchEvent(createCustomEvent(event));
};

export { createCustomEvent, createCustomKeyboardEvent, setInputValueByRef };
//# sourceMappingURL=input.js.map
